module.exports = __webpack_public_path__ + "img/explain.cb6fbcd.svg";